const messages = {
    preventPlay: 'Recuerda mantener tu cuenta desconectada del juego para que los cambios surtan efecto.'
}
export default messages